import { notStartedImgUrlImg } from '@components/Component/OLP/tab/ActivityFactory/ActivityFactory';
import React from 'react';
import { useIsTeacher } from '@reducers/user/hooks';
import InformationCard from '@components/Component/InformationCard';
import { Testlet, TestletStatus } from '../../types';

const NotLockedTestletFallback = ({
  children,
  ...props
}: {
  children: React.ReactNode;
  data: Testlet;
}) => {
  const isTeacher = useIsTeacher();
  if (isTeacher) {
    return children;
  }
  const { data } = props;
  if (data.status === TestletStatus.LOCKED || data.status === TestletStatus.COMPLETED) {
    return children;
  }

  return (
    <InformationCard
      img={notStartedImgUrlImg}
      title="Not Available yet."
      description="This report will be available once the testlet is locked."
    />
  );
};

export default NotLockedTestletFallback;
